<template>

    <div id="addTask">
      <h3 class="text-center pt-5 text-info">Add Task Form</h3>
      <div class="container">
        <div id="addTask-row" class="row justify-content-center align-items-center">
          <div id="addTask-column" class="col-md-6">
            <div id="addTask-box" class="col-md-12">
              <form id="addTask-form" class="form" v-on:submit.prevent="addTask">
                <h3 class="text-center text-info">Add Task</h3>
                <div class="form-group">
                  <label for="username" class="text-info">Title:</label>
                  <br />
                  <input
                    type="text"
                    name="username"
                    id="username"
                    class="form-control"
                    v-model="addTaskTitle"
                  />
                </div>
                <div class="form-group">
                  <label for="email" class="text-info">Description:</label>
                  <br />
                  <input
                    type="text"
                    name="email"
                    id="email"
                    class="form-control"
                    v-model="addTaskDescription"
                  />
                </div>
                
                <div class="form-group">
                  <input type="submit" name="submit" class="btn btn-info btn-md" value="Save Task" />
                  <a class="text-info" v-on:click="homePage()">Back to Home</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: "AddTask",
  props:["addTaskCategoryId"],
  data() {
    return {
      addTaskTitle: "",
      addTaskDescription: ""
    };
  },
  methods:{
    homePage(){
      this.$emit('homePage')
    },
    addTask(){
      let payload={
        title:this.addTaskTitle,
        description:this.addTaskDescription,
        id:this.addTaskCategoryId,
      }
      this.$emit('addTask',payload)
      
    }
  }
};
</script>

<style>
</style>